module.exports = __webpack_public_path__ + "img/problem_cover_02.650ea5be.jpg";